import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import logo from "../branding/current/logo.png";
import logoDark from "../branding/current/logo_dark.png";

export class FourOFour extends React.Component {
  render() {
    const { contrast, l10n } = this.props;
    return (
      <div className="callFullscreen">
        <header className="inCallHeader branding-header">
          <img
            className="logo"
            src={contrast ? logoDark : logo}
            alt={l10n("error.404")}
          />
        </header>
        <div className="box callContainer">
          <main className="row content margin-0_1em call-center">
            <div className={"text-align-center margin-auto"}>
              <h1>{l10n("error.404")}</h1>
            </div>
          </main>
        </div>
      </div>
    );
  }
}

FourOFour.propTypes = {
  l10n: PropTypes.func.isRequired,
  contrast: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  l10n: state.config.text,
  contrast: state.accessibility.isHighContrast,
});

export default connect(mapStateToProps)(FourOFour);






// WEBPACK FOOTER //
// ./src/containers/FourOFour.js